var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGraphRise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 3.25C3.66421 3.25 4 3.58579 4 4V18C4 18.6904 4.55964 19.25 5.25 19.25H21.25C21.6642 19.25 22 19.5858 22 20C22 20.4142 21.6642 20.75 21.25 20.75H5.25C3.73122 20.75 2.5 19.5188 2.5 18V4C2.5 3.58579 2.83579 3.25 3.25 3.25Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7803 6.46967C21.0732 6.76256 21.0732 7.23744 20.7803 7.53033L15.2803 13.0303C14.9874 13.3232 14.5126 13.3232 14.2197 13.0303L11.25 10.0607L6.78033 14.5303C6.48744 14.8232 6.01256 14.8232 5.71967 14.5303C5.42678 14.2374 5.42678 13.7626 5.71967 13.4697L10.7197 8.46967C11.0126 8.17678 11.4874 8.17678 11.7803 8.46967L14.75 11.4393L19.7197 6.46967C20.0126 6.17678 20.4874 6.17678 20.7803 6.46967Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraphRise);
export default __webpack_public_path__ + "static/media/ic-graph-rise.38a5838691937d98264962c57dc510eb.svg";
export { ForwardRef as ReactComponent };